import { Layout } from 'antd'
import styled from 'styled-components'

export type BaseLayoutContentProps = { $centered?: boolean }

export const BaseLayoutContent = styled(Layout.Content)<BaseLayoutContentProps>`
  display: flex;
  flex-direction: column;
  padding: 0 16px;

  ${({ $centered }) =>
    $centered
      ? `
    justify-content: center;
    align-items: center;
  `
      : ''}
`
